import React, { useState } from "react";
import "../../styles/cardUserScreen.css";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Header from "../../components/Header/Header.js";

const EducationPay = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cardDetails = {} } = location.state || {};

  const [showPayment, setShowPayment] = useState(false);

  // Session fee entered by user
  const [sessionAmount, setSessionAmount] = useState("");

  // Number of sessions
  const [sessionCount, setSessionCount] = useState(1);

  const MIN_AMOUNT = 100;
  const MAX_AMOUNT = 1400;

  const handleBack = () => {
    if (showPayment) {
      setShowPayment(false);
    } else {
      navigate("/AddtutorFlow");
    }
  };

  // Safely get initials
  const initials = cardDetails?.accountHolderName
    ? cardDetails.accountHolderName
        .split(" ")
        .filter(Boolean)
        .map((word) => word.charAt(0))
        .join("")
    : cardDetails.beneficiaryName
      ? cardDetails.beneficiaryName
          .split(" ")
          .filter(Boolean)
          .map((word) => word.charAt(0))
          .join("")
      : "";

  const numericSessionAmount = Number(sessionAmount);

  const isValidSessionAmount =
    sessionAmount !== "" &&
    Number.isFinite(numericSessionAmount) &&
    numericSessionAmount >= MIN_AMOUNT;

  // Final amount = session fee × number of sessions
  const totalAmount = isValidSessionAmount
    ? numericSessionAmount * sessionCount
    : 0;

  // Handle session fee input
  const handleAmountChange = (e) => {
    const value = e.target.value;

    // Allow only numbers
    if (/^\d*$/.test(value)) {
      setSessionAmount(value);
    }
  };

  // Decrease session count
  const handleDecreaseSession = () => {
    setSessionCount((prev) => Math.max(1, prev - 1));
  };

  // Increase session count
  const handleIncreaseSession = () => {
    setSessionCount((prev) => prev + 1);
  };

  const handleProceed = () => {
    if (!isValidSessionAmount || sessionCount < 1) {
      return;
    }

    setShowPayment(true);
  };

  const handlePay = () => {
    if (!isValidSessionAmount || sessionCount < 1) return;

    console.log("Session Amount:", numericSessionAmount);
    console.log("Number of Sessions:", sessionCount);
    console.log("Total Amount:", totalAmount);

    navigate("/EducationPaycheckout", {
      state: {
        ...cardDetails,

        // Amount for one session
        sessionAmount: numericSessionAmount,

        // Number of sessions
        sessionCount: sessionCount,

        // Final calculated amount
        amount: totalAmount,
        actualAmount: totalAmount,
        totalAmount: totalAmount,

        subService: "School Fee",
        serviceName: "Education",
      },
    });
  };

  return (
    <>
      <Header title="Tutor Payment" />

      <div className="education_pay_container pay_pv_div_s">
        <div className="payment-modal">
          {/* Top Navigation Bar */}
          <div className="payment-modal-top-bar">
            <button
              className="modal-back-btn"
              type="button"
              aria-label="Back"
              onClick={handleBack}
            >
              <KeyboardBackspaceIcon />
            </button>

            <button
              className="close-btn"
              type="button"
              aria-label="Close"
              onClick={() => navigate("/AddtutorFlow")}
            >
              ×
            </button>
          </div>

          {/* ================= PROFILE ================= */}
          <div className="profile-section">
            <div className="avatar">{initials}</div>

            <h2>{cardDetails?.accountHolderName || cardDetails?.beneficiaryName}</h2>
          </div>

          {!showPayment ? (
            /* ==================================================
               STEP 1 - TUTOR DETAILS + SESSION SELECTION
               ================================================== */
            <>
              {/* Account details */}
              <div className="account-section">
                <div className="detail-row">
                  <span>Account No.</span>
                  <strong>••••••{cardDetails?.accountNumber?.slice(-4) || cardDetails?.beneficiaryAccountNumber?.slice(-4)}</strong>
                </div>

                <div className="detail-row">
                  <span>PAN</span>
                  <strong>
                    {cardDetails?.pan?.slice(0, 2) || cardDetails?.customerPan?.slice(0, 2)}••••••
                    {cardDetails?.pan?.slice(-2) || cardDetails?.customerPan?.slice(-2) }
                  </strong>
                </div>
              </div>

              {/* Description */}
              <div className="description">
                Computer science tutor with expertise in programming,
                algorithms, and logical reasoning for competitive exams and
                coursework.
              </div>

              {/* ================= SESSION FEE ================= */}
              <div className="session-section">
                <div className="session-left">
                  <div className="session-title">SESSION FEE</div>

                  <div className="session-duration">60 min / Session</div>
                </div>

                {/* Session amount input */}
                <div className="session-amount-input">
                  <span>₹</span>

                  <input
                    type="text"
                    inputMode="numeric"
                    value={sessionAmount}
                    onChange={handleAmountChange}
                    placeholder="0"
                    maxLength={5}
                  />

                  <span className="session-label">/session</span>
                </div>
              </div>

              {/* Amount validation */}
              {sessionAmount !== "" && numericSessionAmount < MIN_AMOUNT && (
                <div className="error-message ps-4">
                  Minimum session amount is ₹{MIN_AMOUNT}
                </div>
              )}

              {/* {sessionAmount !== "" && numericSessionAmount > MAX_AMOUNT && (
                <div className="error-message ps-4">
                  Maximum session amount is ₹{MAX_AMOUNT}
                </div>
              )} */}

              {/* <div className="amount-info ps-4">
                Session amount must be greater than ₹100
              </div> */}

              {/* ================= NUMBER OF SESSIONS ================= */}
              <div className="session-count-section ms-3 me-3">
                <div>
                  <div className="session-count-title">NUMBER OF SESSIONS</div>

                  <div className="session-count-subtitle">
                    Select number of sessions
                  </div>
                </div>

                <div className="session-counter">
                  <button
                    type="button"
                    onClick={handleDecreaseSession}
                    disabled={sessionCount <= 1}
                    aria-label="Decrease sessions"
                  >
                    −
                  </button>

                  <span>{sessionCount}</span>

                  <button
                    type="button"
                    onClick={handleIncreaseSession}
                    aria-label="Increase sessions"
                  >
                    +
                  </button>
                </div>
              </div>

              {/* ================= TOTAL ================= */}
              <div className="session-total-section ms-3 me-3">
                <span>Total Amount</span>

                <strong>₹{totalAmount}</strong>
              </div>

              {/* ================= ACTIONS ================= */}
              <div className="actions">
                <button
                  className="cancel-btn"
                  onClick={() => navigate("/AddtutorFlow")}
                >
                  Cancel
                </button>

                <button
                  className="proceed-btn"
                  onClick={handleProceed}
                  disabled={!isValidSessionAmount}
                >
                  Proceed
                </button>
              </div>

              <div className="terms">
                By proceeding you agree to our terms and conditions
              </div>
            </>
          ) : (
            /* ==================================================
               STEP 2 - PAYMENT SUMMARY
               ================================================== */
            <>
              {/* Skills */}
              <div className="skills-section">
                <div className="skills-title">SKILLS</div>

                <div className="skills-list">
                  <span>Python</span>
                  <span>Java</span>
                  <span>Algorithms</span>
                  <span>Data Structures</span>
                  <span>SQL</span>
                  <span>Debugging</span>
                </div>
              </div>

              {/* ================= PAYMENT SUMMARY ================= */}
              <div className="payment-summary">
                <div className="payment-summary-row">
                  <span>Session Fee</span>

                  <strong>₹{numericSessionAmount}</strong>
                </div>

                <div className="payment-summary-row">
                  <span>Number of Sessions</span>

                  <strong>{sessionCount}</strong>
                </div>

                <div className="payment-summary-divider" />

                <div className="payment-summary-total">
                  <span>TOTAL AMOUNT</span>

                  <strong>₹{totalAmount}</strong>
                </div>
              </div>

              {/* Pay button */}
              <div className="pay-section">
                <button
                  className="pay-btn"
                  disabled={!isValidSessionAmount}
                  onClick={handlePay}
                >
                  Pay ₹{totalAmount}
                </button>
              </div>

              <div className="terms">
                By proceeding you agree to our terms and conditions
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default EducationPay;
